// === GENERATED FILE ===
// DO NOT EDIT DIRECTLY, EDIT sh-switch.lit.scss INSTEAD!
import { css } from 'lit-element';
export default css`:host {
  display: flex;
  flex-direction: row;
  border-radius: var(--sh-switch-border-radius);
  background-color: rgba(var(--ui-1), var(--opacity-7));
  width: -webkit-fit-content;
  width: fit-content;
  width: -ms-fit-content;
  width: -moz-fit-content;
  max-width: 100%;
  overflow: hidden;
}

:host([stretch]) {
  width: 100%;
}

:host([stretch]) > ::slotted(sh-switch-item) {
  flex: 1;
}

:host([disabled]) {
  pointer-events: auto;
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([condensed]) {
  border-radius: var(--sh-switch-condensed-border-radius);
}

:host > ::slotted(sh-switch-item) {
  flex: 1;
}`;